import Choices from 'choices.js';

export default (form) => {
    const selects = Array.from(form.querySelectorAll('select'));

    selects.forEach((select) => {
        new Choices(select, {
            searchEnabled: false,
            itemSelectText: '',
            placeholder: true,
            shouldSort: false
        });
    });
};
